import { PortalClientStorage } from '../client-storage/storage';
import axios from '../../axios-interceptor';
import { environment } from '../../environments/environment';

const baseURL = environment.baseURL;
const refreshTokenByEmail = true;
let lastRefreshTokenTry = null;
const differenceOfSecondsToConsiderInLoop = 5;

/**
 * Function to know if we are in refresh token loop. 
 * To know that, it uses the saved time of the last refresh token try, and calculate the difference of seconds with the now date
 */
const isInRefreshTokenLoop = () => {
    if (lastRefreshTokenTry === null) {
        return false;
    } else {
        const differenceInSeconds = Math.abs(lastRefreshTokenTry.getTime() - new Date().getTime) / 1000;

        if (differenceInSeconds <= differenceOfSecondsToConsiderInLoop) {
            return true;
        }

        lastRefreshTokenTry = new Date();
        return false;
    }
}

/**
 * Handle the API token refresh if it's possible.
 * To refresh the token, we ensure the following points :
 *      - the application is not in a token refresh loop
 *      - the application already knows a token
 *      - the application refresh token by email OR the application knows the refresh token
 * @returns a promise of the refresh token
 */
const handleApiTokenRefresh = () => {
    if (!isInRefreshTokenLoop() && apiTokenExists() && (refreshTokenByEmail || apiRefreshTokenExists())) {
        return refreshToken();
    }
};

/**
 * Initialize the API token in the application storage
 * @param {{accessToken, refreshToken}} apiToken 
 */
const initializeApiToken = (apiToken) => {
    if (apiToken && apiToken.accessToken) {
        PortalClientStorage.setData('apiToken.accessToken', apiToken.accessToken,false); 
        PortalClientStorage.setData('accessToken', apiToken.accessToken,true); 
    }

    if (apiToken && apiToken.refreshToken) {
        PortalClientStorage.setData('apiToken.refreshToken', apiToken.refreshToken);
    }
};

const apiTokenExists = () => {
    return !!PortalClientStorage.getData('apiToken.accessToken') && PortalClientStorage.getData('apiToken.accessToken') != null;
}

const apiRefreshTokenExists = () => {
    return !!PortalClientStorage.getData('apiToken.refreshToken');
}

/**
 * Refresh the token in the API and initialize correctly the new refreshed token in storage
 * This function uses email or refresh token
 * @returns a promise of token been refreshed
 */
const refreshToken = () => {
    return new Promise((resolve, reject) => {
        axios.post(
        `${baseURL}/security/token/refresh`,
            (refreshTokenByEmail 
                ?   {userEmail: JSON.parse(localStorage.getItem('userDetails'))?.email}
                :   {refreshToken: PortalClientStorage.getData('apiToken.refreshToken')}
            )        
        ).then((data) => {
            initializeApiToken({accessToken: data?.data?.data?.Token, refreshToken: data?.data?.data?.refreshToken});
            resolve();
        })
        .catch(() => {
            reject();
        })
    });
}

const getApiToken = () => {
    return PortalClientStorage.getData('accessToken',true);
}

const resetTokenData = () => {
    PortalClientStorage.removeData('apiToken.accessToken');
    PortalClientStorage.removeData('apiToken.refreshToken');
}

const doesTokenExist = () => {
    const token = getApiToken();
    if(token !== null && token !== undefined ){
        return true;
    }else{
        return false;
    }
}

export const PortalApiToken = {
    handleApiTokenRefresh,
    initializeApiToken,
    getApiToken,
    resetTokenData,
    apiTokenExists,
    doesTokenExist,
    refreshToken
};
